<template>
<div class="christmas2023">
    <SimpleHead />
    <div class="banner only-pc" style="background-image:url(https://media1.imgyb.xyz/media/v1/image/e61da8754c090433ef80dfe77fc31067.png)">
        <div class="container"><img src="https://media2.imgyb.xyz/media/v1/image/f0d9efc43870b73c5752e8a00bc5587d.png" alt=""></div>
    </div>
    <div class="banner only-mobile">
        <img src="https://media6.imgyb.xyz/media/v1/image/6fd2110676dc28a03a3483ba778d85c7.png" alt="">
    </div>
    <div class="banner only-pc">
        <div class="blk-link">
            <a href="https://www.globalfitfinancial.com/" target="_blank"><img src="https://media6.imgyb.xyz/media/v1/image/458f70e7ee7d243032abf0a834c781f9.jpeg" alt=""></a>
            <a href="https://www.globalfitfinancial.com/" target="_blank"><img src="https://media4.imgyb.xyz/media/v1/image/4c0fadff7fbd407589b62a11f2130d79.jpeg" alt=""></a>
            <a href="https://www.globalfitfinancial.com/" target="_blank"><img src="https://media3.imgyb.xyz/media/v1/image/cf6bf5b76a37c35231a11551678365ee.jpeg" alt=""></a>
            <a href="https://www.globalfitfinancial.com/" target="_blank"><img src="https://media2.imgyb.xyz/media/v1/image/24cdc5a266b9deeb216d2a2aa3b3dffe.jpeg" alt=""></a>
        </div>
        
        
        
        
        
        
        <img src="https://media6.imgyb.xyz/media/v1/image/c1a60df5ae514007b403455e6afb4993.jpeg" alt="">
        <img src="https://media4.imgyb.xyz/media/v1/image/417b7e7b1454bdddcca436dfa29c02c7.jpeg" alt="">
        <img src="https://media7.imgyb.xyz/media/v1/image/3b5cfb8d06a9aff9b6b4e62ef05dd109.jpeg" alt="">
        <img src="https://media1.imgyb.xyz/media/v1/image/1d4b7e6b90cec180c6d62e2824fd44b7.jpeg" alt="">
        <img src="https://media1.imgyb.xyz/media/v1/image/b727570b47c2283376685ec1551579a1.jpeg" alt="">
        <img src="https://media1.imgyb.xyz/media/v1/image/eba3aef47cc3fd3df997fc12583a5b2d.jpeg" alt="">
        <img src="https://media1.imgyb.xyz/media/v1/image/59cf4ca4cd2d197943b048cf3c6960b9.jpeg" alt="">
        <img src="https://media6.imgyb.xyz/media/v1/image/b45dd247de3e453e31d8317e70154057.jpeg" alt="">
        <div class="view-detail">
            <img src="https://media3.imgyb.xyz/media/v1/image/f2677b824f45a293f8c7aff9d18c3e32.jpeg" alt="">
            <div class="link-cont"><a href="https://forum.yorkbbs.ca/detail/65987b98-39ad-4dff-af66-f05623ecbcac?topic=chat" target="__blank"><img src="https://media2.imgyb.xyz/media/v1/image/e751a1edf7074b51db911b7a6b0594f9.png" alt=""></a></div>
        </div>
        
        <img src="https://media7.imgyb.xyz/media/v1/image/b503a25731141a13fb1837a0dc0826b8.jpeg" alt="">
        
    </div>
    <div class="banner only-mobile">
        <div><a href="https://www.globalfitfinancial.com/"  target="_blank"><img src="https://media2.imgyb.xyz/media/v1/image/af99920f764635a677384ec272757877.png" alt=""></a></div>
        
        <img src="https://media7.imgyb.xyz/media/v1/image/c52af7204588a3a9eb7ceb64a6199358.png" alt="">
        <img src="https://media6.imgyb.xyz/media/v1/image/8b64a30e2cded345befc2b839996d979.png" alt="">
       
        <div class="view-detail">
            <img src="https://media7.imgyb.xyz/media/v1/image/aa3315fa1f068587a7899f0e9225fe65.png" alt="">
            <div class="link-cont"><a href="https://forum.yorkbbs.ca/detail/65987b98-39ad-4dff-af66-f05623ecbcac?topic=chat" target="__blank"><img src="https://media2.imgyb.xyz/media/v1/image/e751a1edf7074b51db911b7a6b0594f9.png" alt="" width="210"></a></div>
        </div>
        
    </div>
    <div class="wrap-content-zone">
        <div class="warp-content">
        
            <div class="lf-cont">
                <div class="cont-row">
                    <div class="title">相关话题</div>
                    <div class="tab">
                        <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选推荐</div>
                    
                        <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
                    </div>
                </div>
                <div class="post-list" v-if="list.length>0">
                    <template v-for="(item,index) in list" >
                        <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :data="item" :key="index"></YorkbbsInfoflowItem>
                        <div class="post-item" v-else :key="item.id"><SubjectPostItem  :data="item" @attention="attention" /></div>
                        
                    </template>

                    
                </div>
                <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
                <div class="loading-style" v-if="!hasMore" >没有更多了</div>
            </div>
            <div class="lr-cont">
               <div class="hot-content">
                    <HotSubject />
                    
                </div>
                <div class="kjwt-column" v-if="!advLoading">
                    <template v-for="item in getAdvLgByName('zhuan_ti_')">
                        <YorkbbsAdvItem :data="adv['zhuan_ti_'+item]" :key="item"></YorkbbsAdvItem>
                    </template>
                    
                </div>
            </div>
        </div>
        <CssFooter />
    </div>
  
    <div class="join-play">
        <div class="box">
            <a @click="postLink($event)" :href="'/publish/dining?subject=78908c95-f2ca-45dd-8e25-214a8bada358'|hostBuild('forum')" target="_blank"><div><i class="el-icon-camera-solid"></i></div> 参与话题</a>
            <!-- <a @click="postLink($event)" href="javascript:void(0)"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a> -->
        </div>

    </div>
</div>
</template>
<script>
import SimpleHead from '@/components/widgets/simple-head.vue'
import { isScrollToPageBottom ,inflowAdvConvert,bannerAdvConvert} from '@/utils/utils';
import { throttle } from 'throttle-debounce';
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'

import SubjectPostItem from '@/components/subject-post-item.vue'
import HotSubject from '@/views/discussion/hot-subject.vue'
import YorkbbsAdvItem from '@/components/item-adv.vue'
import CssFooter from '@/components/css-footer.vue'
export default {
    name:'Christmas2023',
    components:{SimpleHead,YorkbbsInfoflowItem,SubjectPostItem,HotSubject,YorkbbsAdvItem,CssFooter},
    data(){
        return  {
            type:2,
            params:{
                subjectIds:['78908c95-f2ca-45dd-8e25-214a8bada358','70b64259-928b-41d7-a184-82484e967b35'],
                dataOrigin:['bbs_post'],
                offset:1,
                size:10,
            },
           
            list:[],
            pageComplete:false,
            hasMore:true,
            listLoading:false,
            adv:{},
            advLoading:true
        }
    },
    created(){
        this.getList();
        this.getAd();
      
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        getAdvLgByName(name){
            var num = 0; 
            for(var key in this.adv){
                if( key.startsWith(name)){
                    num++;
                }
            }
            return num
        },
        async getAd(){
            //9000273
         
            let result = await this.$axios.post('/crm/section/v1/get/list/open',{id:9000273});
            this.advLoading = false;
            if( result.code == 0 ){
                this.adv = bannerAdvConvert(result.data, 'zhuan_ti', 9000273);
                console.log('获取的广告--->',this.adv);
            }
        },
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_top: DESC','property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.hasMore = true;
            this.list = [];
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            
            if( this.params.offset == 1 ){
                this.list = [];
            }
            if( this.type == 0 ){
                let result = await this.$axios.post('/subject/v1/post/list/recommended/for/special',this.params);
    
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
              
       
            }else{
                let result = await this.$axios.post('/subject/v1/post/list/latest/for/special',this.params);
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
             
            }
           

            this.pageComplete = true;
            this.listLoading = false;
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            /* let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            } */
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
        postLink(event){
            console.log(event);
            try{
                
                flutterForumPost.postMessage(JSON.stringify({
                    topicId:'9f6ada73-4a8c-457f-8bd9-b9eca97ee4b0',
                    subject:'78908c95-f2ca-45dd-8e25-214a8bada358',
                    name:'美食'
                }))
                event.preventDefault()
                return false;
            }catch(err){
                return true;
            }
            
        },
        attention(obj){
            console.log(obj);
            for(var i=0; i<this.list.length;i++){
                if(this.list[i].app != 'bbs_post') continue;
                if( this.list[i].user.id == obj.id){
                    this.list[i].user.focusedByMe = obj.val;
                }
            }
        },
        
    }
}
</script>
<style lang="less" scoped>

@media screen and (max-width:768px){
    .warp-content{
        .lf-cont{padding: 0 10px;}
        .lr-cont{display: none;}
    }
}
@media screen and (min-width:768px){
    .christmas2023{
        min-width: 1200px;
        margin:0 auto; 
        padding-bottom: 80px;
        
    }
    .warp-content{
        width:1200px;
        margin: 0 auto;
    }
}
.blk-link{
    a{display: block;}
}
.banner{
    background-position: center top;
    img{display: block; max-width: 100%; margin: 0 auto;}
    .view-detail{
        position: relative; z-index: 1;
        .link-cont{
            position: absolute; left: 0; top: 0; right: 0; display: flex; justify-content: center;
        }
    }
}
@media screen and (min-width:768px){
    .wrap-content-zone{
        background-color: #018a5e;
        background-image:url("https://media2.imgyb.xyz/media/v1/image/5d337285e126b7e4d6fd713a003003c6.jpeg"),url("https://media6.imgyb.xyz/media/v1/image/24355353f71d2e00d4a46af0a7d2a19c.jpeg"),url('https://media5.imgyb.xyz/media/v1/image/4a6fcff86d6e5d0c882bf87c7619f09e.jpeg');
        background-position: center top,center top,center bottom;        
        background-repeat: no-repeat;
    }
    
}
@media screen and (max-width:768px){
    .wrap-content-zone{
        background-color: #018a5e;
        background-image:url("https://media7.imgyb.xyz/media/v1/image/d6b625e19803553f3acbb5d438b1c63a.png"),url('https://media2.imgyb.xyz/media/v1/image/8ddcb9eef2f39174981074e90165f68b.png');
        background-position: center top, center bottom;
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .warp-content{
        .lf-cont{
            .cont-row{
                .title{display: none;}
                .tab{
                    justify-content: center; width: 100%;
                    .item{margin-right: 20px;}
                }
            }
        } 
    }
}
.warp-content{
    display: flex;  padding-top: 100px;
    .lf-cont{
        flex:1; overflow: hidden;
        .cont-row{
            display: flex; align-items: center; margin-bottom: 20px;
            .title{
                flex:1; font-size: 16px; font-weight: bold; color: #fff;
            }
            .tab{
                display: flex; align-items: center; font-size: 14px; color: rgba(255,255,255,0.7); 
                .item{margin-left: 20px; cursor: pointer; user-select: none;
                    &.active{color:rgba(255,255,255,1)}
                }
                
            }
        }
    }
    .lr-cont{
        width:300px; margin-left: 30px; padding-top: 36px;
        /deep/ .hot-subject{margin-bottom: 0;}
    }
}   
.post-list{
    .post-item{
        background: #fff;
        border-radius: 8px;
        margin-bottom: 20px;
        padding: 20px 20px;
    }
}
.hot-content{
    background: #fff;
        border-radius: 8px;
        margin-bottom: 20px;
        padding: 20px 20px;
}
.loading-style{display: flex; margin-bottom: 20px; color: #fff; justify-content: center ; align-items: center; font-size: 12px;
    i{margin-right: 5px;}
}
.no-data{
    text-align: center; padding-top: 50px;
    img{margin-bottom: 20px;}
    .text{font-size: 16px; color: #fff; opacity: 0.6;}
}
.kjwt-column{
    a{margin-bottom: 10px;}
}

@media screen and (max-width:768px){
    .join-play{
        position: fixed; z-index: 10; bottom: 150px;  right: 10px;
        .box{
            display: flex; flex-direction: column; align-items: center; justify-content: center; color: #fff; font-size: 20px; 
            //background: linear-gradient(123deg,#ff6496 6%, #fa4a83 21%, #fa4a83 66%);
            background: #f33738;
            width:76px; height: 76px; user-select: none; cursor: pointer;
            font-size: 12px; color: #fff; text-align: center;
            border-radius: 50%;
            i{font-size: 24px; margin-bottom: 3px;}
            &:hover{
                background: #f6354e; color: #fff;
            }
        }
    }  
}
@media screen and (min-width:768px){
    .join-play{
        position: fixed; z-index: 10; bottom: 0; left: 0; right: 0;  background: #fff; padding: 20px 3%;
        .box{
            display: flex;  align-items: center; justify-content: center; color: #fff; font-size: 20px; 
            //background: linear-gradient(123deg,#ff6496 6%, #fa4a83 21%, #fa4a83 66%);
            background: #f33738;

            height: 40px; user-select: none; cursor: pointer;
            font-size: 20px;  text-align: center;
            border-radius: 25px;
            i{font-size: 24px; margin-right: 5px;}
            a{display: flex; align-items: center;}
            &:hover{
                background: #f6354e; color: #fff;
            }
        }
    }
}
</style>